import { task } from 'ember-concurrency';

import { later } from '@ember/runloop';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type IntlService from 'ember-intl/services/intl';
import { TVariant } from '../bv-text';

interface IArgs {
  text: string;
  label?: string;
  variant?: TVariant;
}

export default class BvCopyText extends Component<IArgs> {
  @service intl!: IntlService;
  @tracked doneMessage?: string;

  copyText = task(async () => {
    try {
      const { text } = this.args;
      await navigator.clipboard.writeText(text);
      this._showMessage('copied');
    } catch (e) {
      this._showMessage('copyFail');
    }
  });

  private _showMessage(message: string) {
    this.doneMessage = this.intl.t(message);
    later(() => {
      if (this.isDestroying || this.isDestroyed) {
        return;
      }
      this.doneMessage = undefined;
    }, 2000);
  }
}
